import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import loadingAnimation from "../loadingAnimation.json";
import Lottie from "lottie-react";
export default function Home() {
  const [moviesTrendingToday, setMoviesTrendingToday] = useState([]);
  const [tvSeriesTrendingToday, setTvSeriesTrendingToday] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const options = {
    method: "GET",
    headers: {
      accept: "application/json",
      Authorization:
        "Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiI0ZmZhM2UxNGQ0ZjMxOTg1NDk5NGE0ZjRjM2I0ODYwOCIsInN1YiI6IjY1NmNhNzlmZTM4YmQ4MDEzODU3MTRjZiIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.dj5HiwpguntzVOpJVHY1sQ7emIQuESxWfM09tKqS9Ss",
    },
  };

  useEffect(() => {
    // Fetch Movies Trending Today
    fetch(
      "https://api.themoviedb.org/3/trending/movie/day?language=en-US",
      options
    )
      .then((response) => response.json())
      .then((data) => setMoviesTrendingToday(data.results))
      .catch((err) => console.error(err));

    // Fetch TV Series Trending Today
    fetch(
      "https://api.themoviedb.org/3/trending/tv/day?language=en-US",
      options
    )
      .then((response) => response.json())
      .then((data) => setTvSeriesTrendingToday(data.results))
      .then(() => setLoading(false))
      .catch((err) => console.error(err));
  }, []);
  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen w-full">
        <Lottie
          animationData={loadingAnimation}
          height={50}
          width={30}
          className="pl-20"
        ></Lottie>
      </div>
    );
  }

  return (
    <div className="bg-[#221F1F]">
      {/* Movies Trending Today */}
      <div>
        <div className="text-[#867d7d] font-sans font-bold p-3 text-left lg:text-white lg:font-poppins">
          Movies Trending Today
        </div>

        <div className="flex space-x-2 overflow-x-auto px-3 no-scrollbar">
          {moviesTrendingToday.map((movie) => (
            <img
              key={movie.id}
              className="w-40 rounded-sm hover:cursor-pointer"
              src={
                movie.poster_path
                  ? `https://image.tmdb.org/t/p/original/${movie.poster_path}`
                  : "loadingAnimation.gif"
              }
              alt={movie.title}
              title={movie.title + " (" + movie.release_date.slice(0, 4) + ")"}
              onClick={() => navigate(`/playvideo/movie/${movie.id}`)}
            />
          ))}
        </div>
      </div>

      {/* TV Series Trending Today */}
      <div>
        <div className="text-[#867d7d] font-sans font-bold p-3 text-left lg:text-white lg:font-poppins">
          TV Series Trending Today
        </div>
        <div className="flex space-x-2 overflow-x-auto px-3 no-scrollbar ">
          {tvSeriesTrendingToday.map((series) => (
            <img
              key={series.id}
              className="w-40 rounded-sm hover:cursor-pointer"
              src={
                series.poster_path
                  ? `https://image.tmdb.org/t/p/original/${series.poster_path}`
                  : "https://cdn.dribbble.com/users/469978/screenshots/10198884/artboard_4x.jpg"
              }
              alt={series.name}
              title={
                series.name + " (" + series.first_air_date.slice(0, 4) + ")"
              }
              onClick={() => navigate(`/playvideo/tv/${series.id}`)}
            />
          ))}
        </div>
      </div>
      <div className="hidden lg:block text-xs my-3 text-gray-700 absolute bottom-1 left-1/2">
        Tip: Use Shift+Scroll to scroll horizontally
      </div>
    </div>
  );
}
